{
  "status": {
    "overdue": "OVERDUE"
  },
  "actions": {
    "create_task": "Create Task",
    "update_task": "Update Task"
  },
  "form": {
    "labels": {
      "due_date": "Due Date",
      "assigned_to": "Assigned To",
      "requested_by": "Requested By",
      "description": "Description"
    },
    "placeholders": {
      "assigned_to": "assigned to",
      "requested_by": "requested by"
    },
    "validation": {
      "task_required": "Please enter a task",
      "date_too_old": "that's too long ago",
      "date_too_far": "that's too far away",
      "task_name_empty": "Task name cannot be empty",
      "unexpected_error": "An unexpected error occurred while adding the task."
    }
  },
  "table": {
    "headers": {
      "tasks": "Tasks",
      "priority": "Priority",
      "due_date": "Due Date",
      "assigned_to": "Assigned To",
      "source": "Source"
    }
  },
  "delete": {
    "confirmation_message": "Click confirm to delete task"
  },
  "aria_labels": {
    "create_new_task": "create new task"
  }
}
